import React, { useCallback } from 'react';
import { SearchInput } from '../../uiKit/inputs';
import { useSelector } from 'react-redux';
import { getGameTypesList } from '../../redux/api/games';

export default React.memo(function GamesListFilters({ searchParams, setSearchParams }) {
  const gameTypes = useSelector(getGameTypesList);

  const onSearchTermChange = useCallback((e) => {
    const term = e.target.value;
    setSearchParams({ ...searchParams, term });
  }, [searchParams, setSearchParams]);

  const selectType = (e) => {
    const id = e.target.dataset.value;
    setSearchParams({ ...searchParams, type: id === 'All' ? undefined : id });
  };

  const types = [{ id: 'All', title: 'All' }, ...gameTypes];

  return (
    <div className={'w-full grid grid-cols-[repeat(auto-fit,minmax(0,8rem))] place-content-center gap-2.5'}>
      <SearchInput placeholder={'Search games'} value={searchParams.term || ''} onChange={onSearchTermChange}
                   wrapperClassName={'col-span-3'} className={'!h-[2.6875rem] !rounded-[6.25rem]'} />
      {types.map(({ id, title }) =>
        <button key={id} onClick={selectType} data-value={id}
                className={`h-[2.6875rem] flex items-center justify-center px-2 py-0.5 bg-white/10 border border-white/20 rounded-[6.25rem] text-white ${searchParams.type?.includes(id) || (id === 'All' && !searchParams.type) ? '!bg-white !text-black' : ''}`}>
          {title}
        </button>
      )}
    </div>
  );
})
